import { render, staticRenderFns } from "./RegisterAgreement.vue?vue&type=template&id=8d0aad5a&scoped=true"
import script from "./RegisterAgreement.vue?vue&type=script&lang=js"
export * from "./RegisterAgreement.vue?vue&type=script&lang=js"
import style0 from "./RegisterAgreement.vue?vue&type=style&index=0&id=8d0aad5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0aad5a",
  null
  
)

export default component.exports